import { render, staticRenderFns } from "./examen-physique-fe.html?vue&type=template&id=0ca4c514&scoped=true&external"
import script from "./examen-physique-fe.js?vue&type=script&lang=js&external"
export * from "./examen-physique-fe.js?vue&type=script&lang=js&external"
import style0 from "./examen-physique-fe.scss?vue&type=style&index=0&id=0ca4c514&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4c514",
  null
  
)

export default component.exports